export const USER_TYPE = {
  PRIVATE_SELLER: 'privateSeller',
  BUSINESS_SELLER: 'businessSeller',
};

export const EMPTY_NAME_PLACEHOLDER = 'N/A';
